export enum CloneType {
  Company = "company",
  Product = "product",
  Service = "service",
}

export interface ICloneType {
  id: number;
  title: string;
  slug: CloneType;
}
